import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserProfile } from '../hooks/useUserProfile';

interface ProfileRestrictedRouteProps {
  children: React.ReactNode;
  restrictedForProfileTypes?: string[];
  redirectTo?: string;
}

const ProfileRestrictedRoute: React.FC<ProfileRestrictedRouteProps> = ({
  children,
  restrictedForProfileTypes = [],
  redirectTo = '/ai-studio'
}) => {
  const { profile, isLoading } = useUserProfile();

  // Get profile type with fallback to localStorage
  const getProfileType = () => {
    if (profile?.profile_type) {
      return profile.profile_type;
    }
    return localStorage.getItem('profile_type');
  };

  const profileType = getProfileType();

  // Show loading state while profile is loading and no cached profile type
  if (isLoading && !profileType) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check if current user's profile type is restricted
  if (profileType && restrictedForProfileTypes.includes(profileType)) {
    console.log(`ProfileRestrictedRoute - Redirecting ${profileType} user from restricted route to ${redirectTo}`);
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProfileRestrictedRoute;